export const getters = {
    getGrupoPermissao: state => state.grupoPermissao,
    getGruposPermissoes: state => state.gruposPermissoes,
    getModalCadastroGrupoPermissao: state => state.modalCadastrarGrupoPermissao,
    getModalExcluirGrupoPermissao: state => state.modalExcluirGrupoPermissao,
    getModalPesquisarGrupoPermissao: state => state.modalPesquisarGrupoPermissao
}

export default {}